import script from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableGenerator.vue?vue&type=script&lang=ts&setup=true"

import "./TableGenerator.vue?vue&type=style&index=0&id=144fbd05&lang=scss&scoped=true"

import exportComponent from "/Users/foresight/Desktop/foresight/web/PPTist-tauri/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-144fbd05"]])

export default __exports__